import React from 'react';
import { clsx } from 'clsx';

interface StatGaugeProps {
  label: string;
  value: number; // 0-100
  detail?: string;
}

export function StatGauge({ label, value, detail }: StatGaugeProps) {
  const color =
    value >= 90
      ? 'var(--tg-error)'
      : value >= 70
      ? 'var(--tg-warning)'
      : 'var(--tg-success)';

  return (
    <div className="flex flex-col gap-1">
      <div className="flex justify-between text-xs">
        <span className="text-tg-text-secondary">{label}</span>
        <span className="text-tg-text font-medium">{value.toFixed(1)}%</span>
      </div>
      <div
        className="h-2 rounded-full overflow-hidden"
        style={{ background: 'var(--tg-border)' }}
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${Math.min(value, 100)}%`, background: color }}
        />
      </div>
      {detail && <span className="text-xs text-tg-text-secondary">{detail}</span>}
    </div>
  );
}
